import React, { useEffect, useMemo } from "react";
import { Outlet, Route, Routes, useParams } from "react-router-dom";
import Heading from "../Component/Heading";
import ImgComp from "../Component/ImgComp";
import axios from "axios";
import HomeContent from "../Modules/HomeContent";
import { useState } from "react";
import NotFound from "./NotFound";
import StartPage from "./StartPage";
import PaymentPage from "./PaymentPage";
import ThankPage from "./ThankPage";
import { useDispatch, useSelector } from "react-redux";
import { resetState } from "../Component/Redux/Feature/UrlSlice";
import HomeContentNew from "../Modules/HomeContentNew";
import { getAllCategoriesThunk } from "../Component/Redux/Feature/CategorySlice";
// import { resetState } from "../Component/Redux/Feature/UrlSlice";
// import "../../public/asset/CSS/Modules/all.scss";
import categoriesData from "../data/categories.json";
import { adminapiUrl } from "../Utils/constants";
import { getContentTypeByCategoryUid } from "../Utils/content";

const Home = (props) => {
  
  const [categorySlug, setCategorySlug] = useState(null);
  const [categories, setCategories] = useState(null);
  const { category } = useParams();

  const [categoriesMap, setCategoriesMap]  = useState({});


  const dispatch = useDispatch();

  
  // useEffect(() => {
  //   dispatch(resetState());
  // }, []);
  
  useEffect(() => {
    // const queryParams = new URLq(window.location.search);

    // console.log("query_params => ", queryParams)

    // const catSlug = queryParams.get("category")

    if(category) setCategorySlug(category)
    
      console.log("Cat slug --->", category)

      const getCategories = async () => {
        const res = await axios.get(
          adminapiUrl+"/read_allbranch_alltypes_allplans",
          // "https://admin-api.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",
          {
            headers: {
              "Content-Type": "application/json",
            },
            mode: "no-cors",
          }
        );
    
        const data = res.data.data;
        setCategories(data?.All_categories);
        if(data?.All_categories) {
          const cat_slug_map = {}
          data?.All_categories.map((cat) => {
            cat_slug_map[cat.slug] = getContentTypeByCategoryUid(cat?.uid)
          })

          console.log("CAT SLUG MAP --> ", cat_slug_map)
          setCategoriesMap(cat_slug_map);
        }

        console.log("categories in sessions => ", data);
      };
      getCategories();

  }, [category]);

  useEffect(() => {
    if(categoriesMap && categorySlug) {
    if(categoriesMap[categorySlug]) document.documentElement.style.setProperty('--global-theme', 'black');
    }
  }, [categorySlug, categoriesMap])

  console.log(categories?.find(cat => cat?.slug == categorySlug)?.uid,"catname")
  const selectedCategoryObj = useMemo(
    () => categories?.find(cat => cat?.slug == categorySlug),
    [categories, categorySlug]
  );

  const appnameMemo = useMemo(
    () => getContentTypeByCategoryUid(selectedCategoryObj?.uid),
    [selectedCategoryObj]
  );

  const catidMemo = useMemo(
    () => selectedCategoryObj?.uid,
    [selectedCategoryObj]
  );
  return (
    <>
      <div className="home-page">
        {categoriesMap[categorySlug] && (
          <>
        <ImgComp />
        <HomeContentNew  appname = {appnameMemo} catid={catidMemo}/>
        </>
        )}
      </div>
    </>
  );
};

export default React.memo(Home);
